module.exports = require('./lib/pinyin-tone-parse')